export default "__VITE_ASSET__CE9823Dk__"